import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
    {
        path: "/bomberos",
        name: "inicioBomberos",
        component: () =>
            import(
                /* webpackChunkName: "inicioBomberos", webpackPrefetch: true */ "../views/pagina/IndexBomberos.vue"
            ),
    },
    {
        path: '/buk',
        name: "buk",
        component: () => import(/* webpackChunkName: "bukIndex", webpackPrefetch: true */ "../views/buk/Index.vue")
    },
    {
        path: '/ualabee',
        component: () =>
            import(
                /* webpackChunkName: "ualabeeHome", webpackPrefetch: true */ "../views/ualabee/Index.vue"
            ),
        children: [{
            path: "/",
            name: "ualabeeIndex",
            component: () => import(/* webpackChunkName: "ualabeeIndex", webpackPrefetch: true */ "../views/ualabee/pagina/Index.vue")
        }]
    },
    {
        path: '/ualabee/mobile',
        name: "ualabeeMobile",
        component: () =>
            import(
                /* webpackChunkName: "ualabeeIndexMobile", webpackPrefetch: true */ "../views/ualabee/pagina/IndexMobile.vue"
            ),
    },
    {
        path: '/unired',
        component: () =>
            import(
                /* webpackChunkName: "uniredHome", webpackPrefetch: true */ "../views/unired/Index.vue"
            ),
        children: [{
            path: "/",
            name: "uniredIndex",
            component: () => import(/* webpackChunkName: "uniredIndex", webpackPrefetch: true */ "../views/unired/pagina/Index.vue")
        }]
    },
    {
        path: '/unired/mobile',
        name: "uniredMobile",
        component: () =>
            import(
                /* webpackChunkName: "uniredIndexMobile", webpackPrefetch: true */ "../views/unired/pagina/IndexMobile.vue"
            ),
    },
    {
        path: '/aeropuerto',
        component: () =>
            import(
                /* webpackChunkName: "aeropuertoHome", webpackPrefetch: true */ "../views/aeropuerto/Index.vue"
            ),
        children: [{
            path: "/",
            name: "aeropuertoIndex",
            component: () => import(/* webpackChunkName: "aeropuertoIndex", webpackPrefetch: true */ "../views/aeropuerto/pagina/Index.vue")
        }]
    },
    {
        path: '/aeropuerto/mobile',
        name: "aeropuertoMobile",
        component: () =>
            import(
                /* webpackChunkName: "aeropuertoIndexMobile", webpackPrefetch: true */ "../views/aeropuerto/pagina/IndexMobile.vue"
            ),
    },
    {
        path: "/aeropuerto/autenticacion",
        name: "aeropuertoAutenticacion",
        component: () => import(/* webpackChunkName: "aeropuertoAutenticacion", webpackPrefetch: true */ "../views/aeropuerto/pagina/Autenticacion.vue")
    },
    {
        path: "/comercio",
        name: "comercio",
        redirect: '/comercio/seleccion',
        component: () => import(/* webpackChunkName: "comercio", webpackPrefetch: true */ "../views/pagina/comercio/Index.vue"),
        children: [
            {
                path: "comercioClaveTecnica",
                name: "comercioClaveTecnica",
                component: () => import(/* webpackChunkName: "comercioClaveTecnica", webpackPrefetch: true */ "../views/pagina/comercio/ComercioClaveTecnica.vue")
            }, {
                path: "seleccion",
                name: "comercioSeleccion",
                component: () => import(/* webpackChunkName: "comercioSeleccion", webpackPrefetch: true */ "../views/pagina/comercio/ComercioSeleccion.vue")
            },
            {
                path: "abono",
                name: "comercioAbono",
                component: () => import(/* webpackChunkName: "comercioAbono", webpackPrefetch: true */ "../views/pagina/comercio/ComercioAbono.vue")
            },
            {
                path: "abono/:rut/:monto/:codigo?",
                name: "comercioAbonoCampaña",
                component: () => import(/* webpackChunkName: "comercioAbono", webpackPrefetch: true */ "../views/pagina/comercio/ComercioAbono.vue")
            },
            {
                path: "registro/:vendedor?",
                name: "comercioRegistro",
                component: () => import(/* webpackChunkName: "comercioRegistro", webpackPrefetch: true */ "../views/pagina/comercio/ComercioRegistro.vue")
            },
            {
                path: "confirmacion",
                name: "comercioConfirmacion",
                component: () => import(/* webpackChunkName: "comercioConfirmacion", webpackPrefetch: true */ "../views/pagina/comercio/ComercioConfirmacion.vue")
            },
            {
                path: "reintento/:identificador/:pass",
                name: "comercioReintento",
                component: () => import(/* webpackChunkName: "comercioReintento", webpackPrefetch: true */ "../views/pagina/comercio/ComercioReintento.vue")
            },
            {
                path: "pago/exitoso",
                name: "comercioTrxExitosa",
                component: () => import(/* webpackChunkName: "comercioTrxExitosa", webpackPrefetch: true */ "../views/pagina/comercio/ComercioTrxExitosa.vue")
            },
            {
                path: "pago/fallido",
                name: "comercioTrxFallida",
                component: () => import(/* webpackChunkName: "comercioTrxFallida", webpackPrefetch: true */ "../views/pagina/comercio/ComercioTrxFallida.vue")
            }],
    },
    {
        path: "/reintento/:identificador/:pass",
        name: "reintento",
        component: () =>
            import(
                /* webpackChunkName: "reintento", webpackPrefetch: true */ "../views/pagina/inicio/Reintento.vue"
            ),
    },
    {
        path: "/estado/pago",
        name: "estadoPago",
        component: () =>
            import(
                /* webpackChunkName: "estadoPago", webpackPrefetch: true */ "../views/pagina/inicio/EstadoPago.vue"
            ),
    },
    {
        path: "/estado/pago/exitoso",
        name: "estadoPagoExitoso",
        component: () =>
            import(
                /* webpackChunkName: "estadoPagoExitoso", webpackPrefetch: true */ "../views/pagina/inicio/EstadoPagoExitoso.vue"
            ),
    },
    {
        path: "/confirmacion",
        name: "confirmacion",
        component: () =>
            import(
                /* webpackChunkName: "confirmacion", webpackPrefetch: true */ "../views/pagina/inicio/Confirmacion.vue"
            ),
    },
    {
        path: "/estado/recarga",
        name: "estadoRecarga",
        component: () =>
            import(
                /* webpackChunkName: "estadoRecarga", webpackPrefetch: true */ "../views/pagina/inicio/estadoRecarga.vue"
            ),
    },
    {
        path: "/metro",
        name: "metroIframe",
        component: () => import(/* webpackChunkName: "metroIframe", webpackPrefetch: true */ "../views/pagina/metro/Formularios.vue")
    },
    {
        path: "",
        name: "home",
        component: () =>
            import(
                /* webpackChunkName: "paginaIndex", webpackPrefetch: true */ "../views/pagina/Index.vue"
            ),
        children: [
            {
                path: "/bip",
                name: "inicioBip",
                component: () =>
                    import(
                        /* webpackChunkName: "inicioBip", webpackPrefetch: true */ "../views/pagina/inicio/IndexBip.vue"
                    ),
            },
            //{
            //    path: "/bomberos",
            //    name: "inicioBomberos",
            //    component: () =>
            //        import(
            /* webpackChunkName: "inicioBomberos", webpackPrefetch: true */ //"../views/pagina/inicio/IndexBomberos.vue"
            //        ),
            //},
            {
                path: "/miclub",
                name: "inicioMiClub",
                component: () =>
                    import(
                        /* webpackChunkName: "inicioMiClub", webpackPrefetch: true */ "../views/pagina/inicio/IndexMiclub.vue"
                    ),
            },
            {
                path: "/pagaenlinea",
                name: "inicioPagaEnLinea",
                component: () =>
                    import(
                        /* webpackChunkName: "inicioPagaEnLinea", webpackPrefetch: true */ "../views/pagina/inicio/IndexPagaEnLinea.vue"
                    ),
            },
            {
                path: "/hites",
                name: "inicioHites",
                component: () =>
                    import(
                        /* webpackChunkName: "inicioHites", webpackPrefetch: true */ "../views/pagina/inicio/IndexHites.vue"
                    ),
            },
            {
                path: "/:id?",
                name: "inicio",
                component: () =>
                    import(
                        /* webpackChunkName: "home", webpackPrefetch: true */ "../views/pagina/inicio/Index.vue"
                    ),
            },
        ],
    },
    {
        path: "/hites/confimacion",
        name: "hitesConfirmacion",
        component: () => import(/* webpackChunkName: "hitesConfirmacion", webpackPrefetch: true */ "../views/pagina/inicio/ConfirmacionHites.vue")
    },
    {
        path: '/hites/mobile',
        name: "hitesMobile",
        component: () =>
            import(
                /* webpackChunkName: "hitesIndexMobile", webpackPrefetch: true */ "../views/pagina/hites/IndexMobile.vue"
            ),
    },
    {
        path: "/metro/app",
        name: "metroApp",
        component: () => import(/* webpackChunkName: "metroApp", webpackPrefetch: true */ "../views/pagina/metro/App.vue")
    },
    {
        path: "/metro/vista",
        name: "metroVista",
        component: () => import(/* webpackChunkName: "metroVista", webpackPrefetch: true */ "../views/pagina/metro/Iframe.vue")
    },

    {
        path: "/metro/confimacion",
        name: "metroConfirmacion",
        component: () => import(/* webpackChunkName: "metroConfirmacion", webpackPrefetch: true */ "../views/pagina/metro/Confirmacion.vue")
    },
    {
        path: "/metro/pago/exitoso",
        name: "metroPagoExitoso",
        component: () => import(/* webpackChunkName: "metroPagoExitoso", webpackPrefetch: true */ "../views/pagina/metro/PagoExitoso.vue")
    },
    {
        path: "/metro/pago/fallido",
        name: "metroPagoFallido",
        component: () => import(/* webpackChunkName: "metroPagoFallido", webpackPrefetch: true */ "../views/pagina/metro/PagoFallido.vue")
    },
    {
        path: "/metro/reintento/:identificador/:pass",
        name: "metroReintento",
        component: () =>
            import(
                /* webpackChunkName: "metroReintento", webpackPrefetch: true */ "../views/pagina/metro/Reintento.vue"
            ),
    },
];

const router = new VueRouter({
    mode: "history",
    routes,
});

export default router;
